import { render, staticRenderFns } from "./releases-list.vue?vue&type=template&id=63fb4fdf"
import script from "./releases-list.vue?vue&type=script&lang=js"
export * from "./releases-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports